var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.75,
    cy: 24,
    r: 21.5,
    stroke: "#EFA433"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.75,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_14870_62672)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6667 24.0027V33C35.6667 34.1046 34.7712 35 33.6667 35H16.3333C15.2288 35 14.3333 34.1046 14.3333 33V24.0027M19 21.5469C19 23.1778 17.6569 24.5 16 24.5C14.4323 24.5 13.1454 23.3163 13.0115 21.8072C12.9962 21.635 13.0224 21.4622 13.0667 21.2951L14.6058 15.4877C14.8382 14.6107 15.6318 14 16.539 14H33.461C34.3682 14 35.1618 14.6107 35.3942 15.4877L36.9333 21.2951C36.9776 21.4622 37.0038 21.635 36.9885 21.8072C36.8546 23.3163 35.5677 24.5 34 24.5C32.3431 24.5 31 23.1778 31 21.5469M19 21.5469C19 23.1778 20.3431 24.5 22 24.5C23.6569 24.5 25 23.1778 25 21.5469M19 21.5469L19.6667 14M25 21.5469C25 23.1778 26.3431 24.5 28 24.5C29.6569 24.5 31 23.1778 31 21.5469M25 21.5469V14M31 21.5469L30.3333 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14870_62672",
    x1: 24.75,
    y1: 0,
    x2: 24.75,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1790E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStoreIcon);
export default __webpack_public_path__ + "static/media/new-store-icon.bc9fa66ca157b3f0fc322a1bccfddc71.svg";
export { ForwardRef as ReactComponent };